
import {
  FETCHING_MYCOLLECTION_FOLIOS, FETCHING_MYCOLLECTION_FOLIOS_SUCCEDDED,
  FETCHING_MYCOLLECTION_FOLIOS_FAILED, INVALIDATE_MYCOLLECTION_FOLIOS,
  INVALIDATE_FILTERED_MYCOLLECTION_FOLIOS,

  CREATING_FOLIO_REQUEST, CREATING_FOLIO_SUCCEDDED, CREATING_FOLIO_FAILED,

  UPDATING_FOLIO_REQUEST, UPDATING_FOLIO_SUCCEDDED, UPDATING_FOLIO_FAILED,

  DELETING_FOLIO_REQUEST, DELETING_FOLIO_SUCCEDDED, DELETING_FOLIO_FAILED,

  FETCHING_FOLIO_REQUEST, FETCHING_FOLIO_SUCCEDDED, FETCHING_FOLIO_FAILED,

  ADD_ASSET_TO_COLLECTION_SUCCEDDED, ADD_ASSETS_TO_SECTION_SUCCEDDED,

  FETCHING_COLLECTION_COLLABORATORS_REQUEST, FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED, FETCHING_COLLECTION_COLLABORATORS_FAILED,
  INVALIDATE_COLLECTION_COLLABORATORS,

  UPDATING_COLLECTION_COLLABORATORS_REQUEST, UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED, UPDATING_COLLECTION_COLLABORATORS_FAILED,

  UPDATING_COLLECTION_LIVE_STATUS_REQUEST, UPDATING_COLLECTION_LIVE_STATUS_SUCCEDDED, UPDATING_COLLECTION_LIVE_STATUS_FAILED,
  FETCHING_FOLIO_SHARED_CONTACTS_REQUEST, FETCHING_FOLIO_SHARED_CONTACTS_SUCCEDDED, FETCHING_FOLIO_SHARED_CONTACTS_FAILED, INVALIDATE_COLLECTION_SHARED_CONTACTS,

  WS_ASSET_PROCESSED,

  FETCHING_COLLECTION_SECTION_REQUEST, FETCHING_COLLECTION_SECTION_SUCCEDDED, FETCHING_COLLECTION_SECTION_FAILED,

  COLLECTION_APPLY_ADDITIONAL_CHANGES, SORT_COLLECTION,

  TOGGLE_IS_READ_COLLABORATION_ACCESS, TOGGLE_IS_WIRTE_COLLABORATION_ACCESS,

  CREATING_COLLECTION_LIST_REQUEST, CREATING_COLLECTION_LIST_SUCCEEDED, CREATING_COLLECTION_LIST_FAILED,

  FETCHING_COLLECTION_LISTS_REQUEST, FETCHING_COLLECTION_LISTS_SUCCEEDED, FETCHING_COLLECTION_LISTS_FAILED,

  FETCHING_COLLECTION_LIST_REQUEST, FETCHING_COLLECTION_LIST_SUCCEEDED, FETCHING_COLLECTION_LIST_FAILED,

  DELETING_COLLECTION_LIST_REQUEST, DELETING_COLLECTION_LIST_SUCCEEDED, DELETING_COLLECTION_LIST_FAILED,

  UPDATING_COLLECTION_LIST_REQUEST, UPDATING_COLLECTION_LIST_SUCCEEDED, UPDATING_COLLECTION_LIST_FAILED,

  ADDING_COLLECTION_TO_LIST_SUCCEEDED, REMOVING_COLLECTION_FROM_LIST_SUCCEEDED,

  FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_REQUEST, FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_SUCCEEDED,
  FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_FAILED,

  SET_COLLECTION_AS_TEMPLATE_REQUEST, SET_COLLECTION_AS_TEMPLATE_SUCCEEDED, SET_COLLECTION_AS_TEMPLATE_FAILED,

  SET_COLLECTION_AS_INTERNAL_REQUEST, SET_COLLECTION_AS_INTERNAL_SUCCEEDED, SET_COLLECTION_AS_INTERNAL_FAILED, FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEEDED, FETCHING_FREQUENTLY_SHARED_ASSETS, FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED,

  FETCHING_STAKEHOLDERS, FETCHING_STAKEHOLDERS_SUCCEEDED, FETCHING_STAKEHOLDERS_FAILED,
  UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION,
  INVALIDATE_FOLIO
} from '../actions/actionTypes.jsx';

import { orderBy } from 'natural-orderby';
import _ from 'lodash';

const listState = {
  loading: false,
  loadMore: true,
  invalidated: true,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1
  }
}
const collectionListState = {
  id: 0,
  updating: false,
  deleting: false,
  loading: false,
  creating: false,
  item: null,
  items: null
}
const initialState = {
  ...listState,
  filtered: {

  },
  folio: {
    creating: false
  },
  customer: {
    item: null,
    type: 'ANONYMOUS',
    generating: false,
    error: null,
    updateLink: {
      updating: false,
      item: null,
      error: null
    }
  },
  sort: {
    type: "Name",
    order: "ASC"
  },
  collectionList: {
    ...collectionListState
  }
};



const folioState = {
  item: null,
  loading: false,
  updating: false,
  deleting: false,
  sharing: false,
  collaborators: {
    loading: false,
    invalidated: true,
    currentPage: -1,
    totalPages: 0,
    loadMore: true,
    items: [],
    updatedCollaborators: []
  },
  sharedContacts: {
    loading: false,
    invalidated: true,
    currentPage: -1,
    totalPages: 0,
    loadMore: true,
    items: []
  }
}

function sortCollections(type, order, items) {
  var resultItems = items;

  if (type != "Name") {
    resultItems = items.filter(item => {
      return item.type != "user_defined"
    }).concat(
      items.filter(item => {
        return item.type == "user_defined"
      }).sort((a, b) => {
        if (type == "Created" && order == "ASC") {
          return new Date(a.createdDate) - new Date(b.createdDate);
        } else if (type == "Created" && order == "DESC") {
          return new Date(b.createdDate) - new Date(a.createdDate);
        } else if (type == "Modified" && order == "ASC") {
          return new Date(a.modifiedDate) - new Date(b.modifiedDate);
        } else if (type == "Modified" && order == "DESC") {
          return new Date(b.modifiedDate) - new Date(a.modifiedDate);
        }
      })
    )
  } else {
    var staticItems = items.filter(item => {
      return item.type != "user_defined"
    })

    var userDefinedItems = items.filter(item => {
      return item.type == "user_defined"
    });

    const sortedItems = orderBy(
      userDefinedItems,
      [asset => asset.name],
      [order == "ASC" ? 'asc' : 'desc']
    )

    resultItems = [...staticItems, ...sortedItems];
  }

  return resultItems;
}

function updateCollectionInArray(collections, collection) {
  if (!collection) {
    return collections;
  }

  var items = collections.map((folio, index) => {
    if (folio.id != collection.id) {
      return folio;
    }
    return {
      ...collection
    };
  })

  return items;
}

export function folioReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_MYCOLLECTION_FOLIOS:
      var list = action.payload.list;

      if (list) {
        const collectionsState = state.filtered[list] || listState;
        return Object.assign({}, state, {
          ...state,
          filtered: {
            ...state.filtered,
            [list]: {
              ...collectionsState,
              loading: true,
              invalidated: true
            }
          }
        })
      }

      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true
      })
    case FETCHING_MYCOLLECTION_FOLIOS_SUCCEDDED:
      var result = action.payload.response;
      var list = action.payload.list;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];

      var items = state.items;
      if (list) {
        const collectionsState = state.filtered[list] || listState;
        items = collectionsState.items;
      }

      if (result.currentPage == 0) {
        items = [...records];
      } else {
        items = [...items, ...records];
      }

      if (list) {
        const collectionsState = state.filtered[list] || listState;

        return Object.assign({}, state, {
          ...state,
          filtered: {
            ...state.filtered,
            [list]: {
              ...collectionsState,
              loading: false,
              items: items,
              pagination: {
                ...collectionsState.pagination,
                current: result.currentPage,
                totalPages: result.totalPages,
                totalRecordsCount: result.totalRecordsCount
              },
              invalidated: false,
            }
          }
        })
      }

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount
        },
        invalidated: false,
      })

    case FETCHING_MYCOLLECTION_FOLIOS_FAILED:
      var list = action.payload.list;

      if (list) {
        const collectionsState = state.filtered[list] || listState;

        return Object.assign({}, state, {
          ...state,
          filtered: {
            ...state.filtered,
            [list]: {
              ...collectionsState,
              loading: false,
              invalidated: false,
              error: action.payload.error
            }
          }
        })
      }

      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error
      })

    case INVALIDATE_MYCOLLECTION_FOLIOS:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: true,
        items: []
      })

    case INVALIDATE_FILTERED_MYCOLLECTION_FOLIOS:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: true,
        filtered: {}
      })

    case CREATING_FOLIO_REQUEST:
      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          creating: true
        }
      });

    case CREATING_FOLIO_SUCCEDDED:
      var id = action.payload.id;

      var items = state.items.slice();
      items.splice(state.items.length, 0, action.payload);

      let uniqueItems = new Set(items).toJSON();

      var collectionSort = window.localStorage.collectionSort ? JSON.parse(window.localStorage.collectionSort) : {};
      var type = collectionSort ? collectionSort.type : "Name";
      var order = collectionSort ? collectionSort.order : "ASCENDING";
      items = sortCollections(type, order, uniqueItems);

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          creating: false
        },
        items: items
      });

    case CREATING_FOLIO_FAILED:
      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          creating: false
        }
      });

    case UPDATING_FOLIO_REQUEST:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: true
          }
        }
      });

    case UPDATING_FOLIO_SUCCEDDED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      var items = updateCollectionInArray(state.items, action.payload.folio);

      if (_.size(items) > 0) {
        var updatedItems = new Set(items).toJSON();
        var collectionSort = window.localStorage.collectionSort ? JSON.parse(window.localStorage.collectionSort) : {};
        var type = collectionSort ? collectionSort.type : "Name";
        var order = collectionSort ? collectionSort.order : "ASCENDING";
        updatedItems = sortCollections(type, order, updatedItems);

        var lists = Object.keys(state.filtered) || [];
        var filteredLists = { ...state.filtered };

        lists.forEach(list => {
          var collectionsState = filteredLists[list] || listState;

          var items = updateCollectionInArray(collectionsState.items, action.payload.folio);
          var updatedListItems = sortCollections(type, order, items);

          filteredLists = Object.assign({}, filteredLists, {
            ...filteredLists,
            [list]: {
              ...collectionsState,
              items: updatedListItems
            }
          })
        })

        return Object.assign({}, state, {
          ...state,
          folio: {
            ...state.folio,
            [id]: {
              ...folio,
              updating: false,
              item: {
                ...folio.item,
                ...action.payload.folio
              }
            }
          },
          items: updatedItems,
          filtered: filteredLists
        });
      }
      else {
        return {
          ...state,
          folio: {
            ...state.folio,
            [id]: {
              ...folio,
              updating: false,
              item: {
                ...folio.item,
                ...action.payload.folio
              }
            }
          },
        }
      }

    case UPDATING_FOLIO_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: false,
            error: action.payload.error
          }
        }
      });


    case COLLECTION_APPLY_ADDITIONAL_CHANGES:
      var id = action.payload.id;
      var changes = action.payload.changes;

      var folio = state.folio[id] || folioState;

      var sections = (folio.item.sections || []).map((section, index) => {
        var sectionChanges = changes.sections[index];

        return {
          ...section,
          ...sectionChanges,
          loading: false,
          fetched: _.get(sectionChanges, "fetched", false)
        }
      })

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          creatingSection: false,
          [id]: {
            ...folio,
            item: {
              ...folio.item,
              sections: sections
            }
          }
        }
      });

    case DELETING_FOLIO_REQUEST:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          deleting: true,
          [id]: {
            ...folio,
            deleting: true
          }
        }
      });

    case DELETING_FOLIO_SUCCEDDED:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      var lists = Object.keys(state.filtered) || [];
      var filteredLists = { ...state.filtered };

      lists.forEach(list => {
        var collectionsState = filteredLists[list] || listState;

        var updated = (collectionsState.items || []).filter(item => {
          return id !== item.id;
        })

        filteredLists = Object.assign({}, filteredLists, {
          ...filteredLists,
          [list]: {
            ...collectionsState,
            items: updated
          }
        })
      })


      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          deleting: false,
          [id]: {
            ...folio,
            deleting: false
          }
        },
        filtered: filteredLists,
        items: state.items.filter((folio, index) => {
          return folio.id != id;
        })
      });

    case DELETING_FOLIO_FAILED:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          deleting: false,
          [id]: {
            ...folio,
            deleting: false
          }
        }
      });

    case INVALIDATE_FOLIO:
      var id = action.payload;
      var folio = state.folio[id] || folioState;
      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          deleting: false,
          [id]: {}
        }
      });

    case FETCHING_FOLIO_REQUEST:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          deleting: false,
          [id]: {
            ...folio,
            loading: true
          }
        }
      });

    case FETCHING_FOLIO_SUCCEDDED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      if (action.payload.folio.sections) {
        var sortedSection = action.payload.folio.sections
          .map(section => {
            return {
              ...section,
              loading: false,
              fetched: false
            }
          });

        action.payload.folio.sections = sortedSection;
      }

      var folios = state.items.map(item => {
        if (item.id == id) {
          return {
            ...item,
            sections: action.payload.folio.sections
          }
        } else {
          return item;
        }
      })

      return Object.assign({}, state, {
        ...state,
        items: folios,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            loading: false,
            item: action.payload.folio
          }
        }
      });

    case FETCHING_FOLIO_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            loading: false,
            item: null,
            error: action.payload.error.errors
          }
        }
      });

    case SORT_COLLECTION:
      var items = state.items;
      var type = action.payload.type;
      var order = action.payload.order;
      items = sortCollections(type, order, items)

      return Object.assign({}, state, {
        ...state,
        sort: {
          type: type,
          order: order
        },
        items: items
      })

    case ADD_ASSET_TO_COLLECTION_SUCCEDDED:
      var collection = action.payload.collection;

      var id = collection.id;
      var currentCollection = state.folio[id] || folioState;

      if (!currentCollection.item) {
        return state;
      }

      var assets = collection.assets.filter((asset) => {
        var found = currentCollection.item.assets.find((item) => {
          return item.id == asset.id;
        })

        return found == null
      });

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...currentCollection,
            item: {
              ...currentCollection.item,
              assets: [...currentCollection.item.assets, ...assets]
            }
          }
        }
      });

    case ADD_ASSETS_TO_SECTION_SUCCEDDED:
      var collectionId = action.payload.collectionId;
      var folio = state.folio[collectionId] || folioState;

      var currentSection = action.payload.section;
      var sectionId = action.payload.id;

      if (!folio.item) {
        return state;
      }

      var sections = (folio.item.sections || []).map((section) => {
        if (section.id === sectionId) {
          var assets = section.assets.filter((asset) => {
            var found = currentSection.assets.find((item) => {
              return item.id == asset.id;
            })

            return found == null
          });

          return {
            ...section,
            assets: [...currentSection.assets, ...assets]
          }
        } else {
          return section;
        }
      });

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [collectionId]: {
            ...folio,
            item: {
              ...folio.item,
              sections: sections
            }
          }
        }
      });

    case FETCHING_COLLECTION_SECTION_REQUEST:
      var collectionId = action.payload.collection;
      var sectionId = action.payload.section;


      var currentCollection = state.folio[collectionId] || folioState;


      var sections = currentCollection.item.sections.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            loading: true,
            fetched: false
          }
        } else {
          return section;
        }
      })

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          creatingSection: false,
          [collectionId]: {
            ...currentCollection,
            item: {
              ...currentCollection.item,
              sections: sections
            }
          }
        }
      });

    case FETCHING_COLLECTION_SECTION_SUCCEDDED:
      var collectionId = action.payload.collection;
      var sectionId = action.payload.section.id;

      var currentCollection = state.folio[collectionId] || folioState;

      var sections = currentCollection.item.sections.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            ...action.payload.section,
            loading: false,
            fetched: true
          }
        } else {
          return section;
        }
      })

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          creatingSection: false,
          [collectionId]: {
            ...currentCollection,
            item: {
              ...currentCollection.item,
              sections: sections
            }
          }
        }
      });

    case FETCHING_COLLECTION_SECTION_FAILED:
      var collectionId = action.payload.collection;
      var sectionId = action.payload.section;

      var currentCollection = state.folio[collectionId] || folioState;

      var sections = currentCollection.item.sections.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            loading: false,
            fetched: false,
            error: action.payload.error
          }
        } else {
          return section;
        }
      })

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          creatingSection: false,
          [collectionId]: {
            ...currentCollection,
            item: {
              ...currentCollection.item,
              sections: sections
            }
          }
        }
      });

    case FETCHING_COLLECTION_COLLABORATORS_REQUEST:
      var id = action.payload;

      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              loading: true
            }
          }
        }
      });

    case FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED:
      var loadMore = action.payload.collaborators.currentPage < action.payload.collaborators.totalPages - 1;
      var id = action.payload.id;
      var records = action.payload.collaborators.records;

      var folio = state.folio[id] || folioState;

      var items = [...folio.collaborators.items, ...records];

      var updatedCollaborators = action.payload.collaborators.currentPage > 0 ? state.folio[id].collaborators.updatedCollaborators : []

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              loading: false,
              invalidated: false,
              items: items,
              currentPage: action.payload.collaborators.currentPage,
              totalPages: action.payload.collaborators.totalPages,
              loadMore: loadMore,
              updatedCollaborators: updatedCollaborators
            }
          }
        }
      });

    case FETCHING_COLLECTION_COLLABORATORS_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              loading: false
            }
          }
        }

      });

    case TOGGLE_IS_READ_COLLABORATION_ACCESS:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      var updatedCollaborators = folio.collaborators.updatedCollaborators;
      var collaborators = folio.collaborators.items;
      var currentCollaborator = action.payload.collaborator;

      if (currentCollaborator.entityType == "user") {
        collaborators = collaborators.map(item => {
          if (item.entityType === "user" && item.user.id === currentCollaborator.user.id) {
            return {
              ...currentCollaborator
            }
          }

          return item;
        })

        var isAlreadySelected = updatedCollaborators.find(item => item.type === currentCollaborator.entityType && item.id === currentCollaborator.user.id);

        var updatedCollaborator = {
          id: currentCollaborator.user.id,
          type: currentCollaborator.entityType,
          read: currentCollaborator.read,
          write: currentCollaborator.write
        }
        if (isAlreadySelected) {
          updatedCollaborators = updatedCollaborators.map(item => {
            if (item.id === currentCollaborator.user.id) {
              return {
                ...updatedCollaborator
              }
            }

            return item;
          })
        } else {
          updatedCollaborators.push(updatedCollaborator);
        }
      }

      if (currentCollaborator.entityType === "user_group") {
        collaborators = collaborators.map(item => {
          if (item.entityType === "user_group" && item.userGroup.id === currentCollaborator.userGroup.id) {
            return {
              ...currentCollaborator
            }
          }

          return item;
        });

        var isAlreadySelected = updatedCollaborators.find(item => item.type === currentCollaborator.entityType && item.id === currentCollaborator.userGroup.id);

        var updatedCollaborator = {
          id: currentCollaborator.userGroup.id,
          type: currentCollaborator.entityType,
          read: currentCollaborator.read,
          write: currentCollaborator.write
        }
        if (isAlreadySelected) {
          updatedCollaborators = updatedCollaborators.map(item => {
            if (item.id === currentCollaborator.userGroup.id) {
              return {
                ...updatedCollaborator
              }
            }

            return item;
          })
        } else {
          updatedCollaborators.push(updatedCollaborator);
        }
      }

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              items: collaborators,
              updatedCollaborators: updatedCollaborators
            }
          }
        }
      })


    case TOGGLE_IS_WIRTE_COLLABORATION_ACCESS:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      var updatedCollaborators = folio.collaborators.updatedCollaborators;
      var collaborators = folio.collaborators.items;
      var currentCollaborator = action.payload.collaborator;

      if (currentCollaborator.write) {
        currentCollaborator.read = true;
      }

      if (currentCollaborator.entityType == "user") {
        collaborators = collaborators.map(item => {
          if (item.entityType === "user" && item.user.id === currentCollaborator.user.id) {
            return {
              ...currentCollaborator
            }
          }

          return item;
        })

        var isAlreadySelected = updatedCollaborators.find(item => item.type === currentCollaborator.entityType && item.id === currentCollaborator.user.id);

        var updatedCollaborator = {
          id: currentCollaborator.user.id,
          type: currentCollaborator.entityType,
          read: currentCollaborator.read,
          write: currentCollaborator.write
        }
        if (isAlreadySelected) {
          updatedCollaborators = updatedCollaborators.map(item => {
            if (item.id === currentCollaborator.user.id) {
              return {
                ...updatedCollaborator
              }
            }

            return item;
          })
        } else {
          updatedCollaborators.push(updatedCollaborator);
        }
      }

      if (currentCollaborator.entityType === "user_group") {
        collaborators = collaborators.map(item => {
          if (item.entityType === "user_group" && item.userGroup.id === currentCollaborator.userGroup.id) {
            return {
              ...currentCollaborator
            }
          }

          return item;
        });

        var isAlreadySelected = updatedCollaborators.find(item => item.type === currentCollaborator.entityType && item.id === currentCollaborator.userGroup.id);

        var updatedCollaborator = {
          id: currentCollaborator.userGroup.id,
          type: currentCollaborator.entityType,
          read: currentCollaborator.read,
          write: currentCollaborator.write
        }
        if (isAlreadySelected) {
          updatedCollaborators = updatedCollaborators.map(item => {
            if (item.id === currentCollaborator.userGroup.id) {
              return {
                ...updatedCollaborator
              }
            }

            return item;
          })
        } else {
          updatedCollaborators.push(updatedCollaborator);
        }
      }

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              items: collaborators,
              updatedCollaborators: updatedCollaborators
            }
          }
        }
      })



    case INVALIDATE_COLLECTION_COLLABORATORS:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              loading: false,
              invalidated: true,
              currentPage: -1,
              totalPages: 0,
              loadMore: true,
              items: []
            }
          }
        }
      });

    case FETCHING_STAKEHOLDERS:
      var id = action.payload.collectionId;
      var folio = state.folio[id] || folioState;
      var type = action.payload.type;
      var items = [];

      if (action.payload.page === 0) {
        items = [];
      }
      else {
        items = _.get(folio, `stakeholders[${type}].items`, []);
      }

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            stakeholders: {
              ...folio.stakeholders,
              [type]: {
                loading: true,
                items: items
              }
            }
          }
        }
      })

    case FETCHING_STAKEHOLDERS_SUCCEEDED:

      var id = action.payload.collectionId;
      var folio = state.folio[id] || folioState;
      var type = action.payload.type;
      var items = [];

      if (_.get(action, "payload.data.currentPage", 0) === 0) {
        items = _.get(action, "payload.data.records")
      }
      else {
        const prevItem = folio.stakeholders[type].items;
        items = [...prevItem, ..._.get(action, "payload.data.records", [])]
      }

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            stakeholders: {
              ...folio.stakeholders,
              [type]: {
                loading: false,
                items: items,
                pagination: {
                  currentPage: _.get(action, "payload.data.currentPage"),
                  totalPages: _.get(action, "payload.data.totalPages"),
                  totalRecordsCount: _.get(action, "payload.data.totalRecordsCount")
                }
              }
            }
          }
        }
      })

    case FETCHING_STAKEHOLDERS_FAILED:

      var id = action.payload.collectionId;
      var folio = state.folio[id] || folioState;
      var type = action.payload.type;
      var items = _.get(folio, `stakeholders[${type}].items`) || [];

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            stakeholders: {
              ...folio.stakeholders,
              [type]: {
                items,
                loading: false,
                error: action.payload.error
              }
            }
          }
        }
      })

    case UPDATING_COLLECTION_COLLABORATORS_REQUEST:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            item: {
              ...folio.item,
              writeAll: action.payload.request.writeAll,
              readAll: action.payload.request.readAll,
            },
            collaborators: {
              ...folio.collaborators,
              updating: true
            }
          }
        }
      });

    case UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED:
      var id = action.payload.id;
      var collaborators = action.payload.collaborators;

      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            item: {
              ...folio.item,
              collaboratorsCount: collaborators.length
            },
            collaborators: {
              ...folio.collaborators,
              updating: false,
              updatedCollaborators: []
            }
          }
        }
      });

    case UPDATING_COLLECTION_COLLABORATORS_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              updating: false
            }
          }
        }

      });

    case UPDATING_COLLECTION_LIVE_STATUS_REQUEST:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: true
          }
        }
      });

    case UPDATING_COLLECTION_LIVE_STATUS_SUCCEDDED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: false,
            item: {
              ...folio.item,
              live: action.payload.folio.live
            }
          }
        },
        items: state.items.map((folio, index) => {
          if (folio.id != id) {
            return folio;
          }

          return {
            ...action.payload.folio
          };
        })
      });

    case UPDATING_COLLECTION_LIVE_STATUS_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: false,
            error: action.payload.error
          }
        }
      });

    case FETCHING_FOLIO_SHARED_CONTACTS_REQUEST:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            sharedContacts: {
              ...folio.sharedContacts,
              loading: true
            }
          }
        }
      });

    case FETCHING_FOLIO_SHARED_CONTACTS_SUCCEDDED:
      var loadMore = action.payload.sharedContacts.currentPage < action.payload.sharedContacts.totalPages;
      var id = action.payload.id;
      var records = action.payload.sharedContacts.records;

      var folio = state.folio[id] || folioState;

      var items = [...folio.sharedContacts.items, ...records];

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.email == y.email;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }

      }, []);

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            item: {
              ...state.folio[id].item,
              sharedRecipientsCount: items.length
            },
            sharedContacts: {
              ...folio.sharedContacts,
              loading: false,
              invalidated: false,
              items: items,
              currentPage: action.payload.sharedContacts.currentPage,
              totalPages: action.payload.sharedContacts.totalPages,
              loadMore: loadMore
            }
          }
        }
      });

    case FETCHING_FOLIO_SHARED_CONTACTS_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            sharedContacts: {
              ...folio.sharedContacts,
              loading: false
            }
          }
        }
      });

    case INVALIDATE_COLLECTION_SHARED_CONTACTS:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            sharedContacts: {
              ...folio.sharedContacts,
              loading: false,
              invalidated: true,
              currentPage: -1,
              totalPages: 0,
              loadMore: true,
              items: []
            }
          }
        }
      });

    case WS_ASSET_PROCESSED:
      var assetId = action.payload.id;

      var collectionIds = Object.keys(state.folio);
      var collections = {};

      collectionIds.forEach((id) => {
        var collection = state.folio[id];

        if (!collection) {
          collections[id] = collection;
          return;
        }

        var collectionItem = {
          ...collection,
          item: {
            ...collection.item,
            assets: collection.item && collection.item.assets != null && collection.item.assets.map((asset) => {
              if (asset.id == assetId) {
                return action.payload;
              } else {
                return asset;
              }
            })
          }
        }

        collections[id] = collectionItem;
      });

      return Object.assign({}, state, {
        ...state,
        folio: collections
      });

    case CREATING_COLLECTION_LIST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          creating: true
        }
      });

    case CREATING_COLLECTION_LIST_SUCCEEDED:
      var id = action.payload.id;

      var items = state.collectionList.items || [];
      items = [...items, action.payload];
      items = _.uniqBy(items, 'id');
      items = _.sortBy(items, 'name');

      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          creating: false,
          items: items
        }
      });

    case CREATING_COLLECTION_LIST_FAILED:
      return Object.assign({}, state, {
        ...state,
        creating: false,
        collectionList: {
          ...state.collectionList,
          error: action.payload
        }
      });

    case FETCHING_COLLECTION_LISTS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          loading: true
        }
      });

    case FETCHING_COLLECTION_LISTS_SUCCEEDED:
      var items = orderBy(
        action.payload || [],
        [item => item.name],
        ['asc']
      );

      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          creating: false,
          items: items
        }
      });

    case FETCHING_COLLECTION_LISTS_FAILED:
      return Object.assign({}, state, {
        ...state,
        creating: false,
        collectionList: {
          ...state.collectionList,
          error: action.payload
        }
      });

    case FETCHING_COLLECTION_LIST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        items: [],
        loading: true,
        invalidated: true
      });

    case FETCHING_COLLECTION_LIST_SUCCEEDED:
      var result = action.payload.folio;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [];
      if (result.currentPage == 0) {
        items = [...records];
      } else {
        items = [...state.items, ...records];
      }

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: result.currentPage,
          totalPages: result.totalPages
        },
        invalidated: false,
      });

    case FETCHING_COLLECTION_LIST_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error
      });

    case DELETING_COLLECTION_LIST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          deleting: true
        }
      })

    case DELETING_COLLECTION_LIST_SUCCEEDED:
      var id = action.payload;

      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          deleting: false,
          items: state.collectionList.items.filter((collectionList, index) => {
            console.log(collectionList.id);
            return collectionList.id != id;
          })
        },
      })

    case DELETING_COLLECTION_LIST_FAILED:
      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          deleting: false
        }
      });

    case UPDATING_COLLECTION_LIST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          updating: true
        }
      })

    case UPDATING_COLLECTION_LIST_SUCCEEDED:

      var id = action.payload.id;
      var collectionList = state.collectionList[id] || collectionListState;
      var items = state.collectionList.items.map((collectionList, index) => {
        if (collectionList.id != id) {
          return collectionList;
        }
        return {
          ...action.payload.collectionList
        };
      })
      var updatedItems = new Set(items).toJSON();

      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          [id]: {
            ...collectionList,
            updating: false,
            item: {
              ...collectionList.item,
              ...action.payload.collectionList
            }
          },
          items: updatedItems
        }
      });

    case UPDATING_COLLECTION_LIST_FAILED:
      return Object.assign({}, state, {
        ...state,
        collectionList: {
          ...state.collectionList,
          updating: false
        }
      });

    case ADDING_COLLECTION_TO_LIST_SUCCEEDED:
      var sourceType = ['owned_by_me', 'collaborated', 'live', 'templates'];
      var source = action.payload.source;
      var target = action.payload.target;
      var collection = action.payload.collection;

      if (target) {
        var collectionsState = state.filtered[target];
        if (collectionsState) {
          return state;
        }

        collectionsState = state.filtered[source] || listState;

        var updated = collectionsState.items;

        if (!sourceType.includes(source)) {
          updated = (collectionsState.items || []).filter(item => {
            return collection !== item.id;
          });
        }


        return Object.assign({}, state, {
          ...state,
          filtered: {
            [source]: {
              ...collectionsState,
              items: updated,
            }
          }
        })
      }

    case REMOVING_COLLECTION_FROM_LIST_SUCCEEDED:
      var list = action.payload.list;
      var collection = action.payload.collection;

      if (list) {
        var collectionsState = state.filtered[list] || listState;

        var updated = (collectionsState.items || []).filter(item => {
          return collection !== item.id;
        })

        return Object.assign({}, state, {
          ...state,
          filtered: {
            [list]: {
              ...collectionsState,
              items: updated,
            }
          }
        })
      }
    case FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_REQUEST:
      var id = action.payload;

      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              loading: true
            }
          }
        }
      });

    case FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_SUCCEEDED:
      var id = action.payload.id;
      var collaborators = action.payload.collaborators;

      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              loading: false,
              invalidated: false,
              items: collaborators,
              updatedCollaborators: []
            }
          }
        }
      });

    case FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            collaborators: {
              ...folio.collaborators,
              loading: false
            }
          }
        }

      });

    case SET_COLLECTION_AS_TEMPLATE_REQUEST:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: true
          }
        }
      });

    case SET_COLLECTION_AS_TEMPLATE_SUCCEEDED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: false,
            item: {
              ...folio.item,
              collectionTemplate: action.payload.folio.collectionTemplate
            }
          }
        },
        items: state.items.map((folio, index) => {
          if (folio.id != id) {
            return folio;
          }

          return {
            ...action.payload.folio
          };
        })
      });

    case SET_COLLECTION_AS_TEMPLATE_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: false,
            error: action.payload.error
          }
        }
      });

    case SET_COLLECTION_AS_INTERNAL_REQUEST:
      var id = action.payload;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: true
          }
        }
      });

    case SET_COLLECTION_AS_INTERNAL_SUCCEEDED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: false,
            item: {
              ...folio.item,
              internal: action.payload.folio.internal,
              live: action.payload.folio.live
            }
          }
        },
        items: state.items.map((folio, index) => {
          if (folio.id != id) {
            return folio;
          }

          return {
            ...action.payload.folio
          };
        })
      });

    case SET_COLLECTION_AS_INTERNAL_FAILED:
      var id = action.payload.id;
      var folio = state.folio[id] || folioState;

      return Object.assign({}, state, {
        ...state,
        folio: {
          ...state.folio,
          [id]: {
            ...folio,
            updating: false,
            error: action.payload.error
          }
        }
      });

    case UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION: {

      const sectionIndex = _.get(action, 'payload.section');
      const collectionId = _.get(action, 'payload.collection');
      const assetsToUpdate = _.get(action, 'payload.assets');
      const editing = _.get(action, 'payload.editing');
      var activeCollection = _.get(state, `folio[${collectionId}].item`);

      if (!activeCollection || editing) {
        return state;
      }

      if (_.size(activeCollection.sections) > 0 && sectionIndex) {
        const updatedSections = activeCollection.sections.map((section, index) => {
          if (index == sectionIndex) {
            return {
              ...section,
              assets: _.get(section, "assets", []).map(asset => {
                const assetToUpdate = _.find(assetsToUpdate, { id: asset.id });
                if (assetToUpdate && !asset.additionalMetadata) {
                  const dimension = assetToUpdate.dimension;
                  return {
                    ...asset,
                    additionalMetadata: {
                      xaxis: dimension.x,
                      yaxis: dimension.y,
                      width: dimension.width,
                      height: dimension.height
                    }
                  }
                }

                return asset;
              })
            }
          }

          return section;
        })
        return Object.assign({}, state, {
          ...state,
          folio: {
            ...state.folio,
            [collectionId]: {
              ...state.folio[collectionId],
              item: {
                ...state.folio[collectionId].item,
                sections: updatedSections
              }
            }
          }
        })
      }
      else {
        const assets = activeCollection.assets;
        var updatedAssets = assets.map(asset => {
          const assetToUpdate = _.find(assetsToUpdate, { id: asset.id });
          if (assetToUpdate && !asset.additionalMetadata) {
            const dimension = assetToUpdate.dimension;
            return {
              ...asset,
              additionalMetadata: {
                xaxis: dimension.x,
                yaxis: dimension.y,
                width: dimension.width,
                height: dimension.height
              }
            }
          }

          return asset;
        });

        return Object.assign({}, state, {
          ...state,
          folio: {
            ...state.folio,
            [collectionId]: {
              ...state.folio[collectionId],
              item: {
                ...state.folio[collectionId].item,
                assets: updatedAssets
              }
            }
          }
        });
      }
    }

    default:
      return state
  }
}
